var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container"},[(_vm.name)?_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e(),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }